import Vue from 'vue'
import axios from 'axios'
import Modal from '../components/modalCerrarSesion.vue'
require('es6-promise').polyfill()

var shared = new Vue({
    el: '#sessionBar',
    components: {
        'modal-sesion': Modal
    },
    data: {
        mesaAyudaAtendiendo: false,
        showModal: false,
        nombreUsuario: '',
        session: false,
        observaciones: [],
        mensaje: '',
        direccion: '',
        usuarioPSSIM: '',
        opcionCerrar: 0,
    },
    methods: {
        existeSession: function () {
            axios.post('/Login/existeSession/').then(response => {
                //TODO: RECONSTRUIR
                var resultado = response.data.resultado;
                var usuario = response.data.usuario;
                var strCurrentPage = window.location.href.toString().split(window.location.host)[1];
                if (resultado == "false" && usuario == "") {
                    if (strCurrentPage != "/") {
                        window.location = "../";
                    }
                    this.nombreUsuario = "Usuario Invitado";
                    this.session = false;
                } else if (resultado == "false" && usuario != "") {
                    if (strCurrentPage == "/") {
                          window.location = "../Portal/listado";
                    }
                    this.nombreUsuario = usuario;
                    this.session = true;
                } else if (resultado == "true" && usuario == "") {
                    this.nombreUsuario = "Usuario Invitado";
                    this.session = false;
                }
            });
        },
        verificarUsuarioPSSIM: function () {
            axios.post('/Login/UsuarioPSSIM/').then(response => {
                var resultado = response.data.resultado;
                var usuario = response.data.usuario;
                if (resultado == "exito" && usuario == "") {
                    this.usuarioPSSIM= "";
                } else if (resultado == "exito" && usuario != "") {
                    this.usuarioPSSIM = usuario;
                    this.mesaAyudaAtendiendo = true;
                }
            });
        },
        cerrarSession: function () {
            axios.post('/Login/cerrarSession/').then(response => {
                if (response.data == "True") {
                    window.location = "../";
                }
            }).catch((error) => {
                console.log(error);
            });
        },
        cerrarSessionPostulante: function () {
            axios.post('/Login/cerrarSessionPostulante/').then(response => {
                if (response.data == "True") {
                    window.location = "../Login/login";
                }
            }).catch((error) => {
                console.log(error);
            });
        },
    },
    mounted: function () {
        this.existeSession();
        this.verificarUsuarioPSSIM();
    }
});





// WEBPACK FOOTER //
// ./Scripts/js/shared/shared.js